/*
 * @Description: 
 * @Author: 李方强
 * @Date: 2019-07-25 16:12:31
 * @LastEditTime: 2021-07-16 15:16:22
 * @LastEditors: lkz
 */
/**
 * import中的webpackChunkName，为按需加载生成的JS名称，请使用 [project-name]-[module-name]，示例如下
 */
export default [
  {
    path: '/configuration-center/customerServiceManaging',
    name: '/configuration-center/customerServiceManaging',
    meta: {
      title: '客服管理-人员管理'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/customerServiceManaging.vue')
  },
  {
    path: '/configuration-center/customerQueueManaging',
    name: '/configuration-center/customerQueueManaging',
    meta: {
      title: '客服管理-技能组管理'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/customerServiceManaging2.vue')
  },
  {
    path: '/configuration-center/customerServiceQueue',
    name: '/configuration-center/customerServiceQueue',
    meta: {
      title: '队列管理'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/customerServiceQueue.vue')
  },
  {
    path: '/configuration-center/customerServiceRoute',
    name: '/configuration-center/customerServiceRoute',
    meta: {
      title: '路由条件'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/customerServiceRoute.vue')
  },
  {
    path: '/configuration-center/customerServiceEditlist',
    name: '/configuration-center/customerServiceEditlist',
    meta: {
      title: '承接人员配置'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/customerServiceEditlist.vue')
  },
  {
    path: '/configuration-center/quick/quick',
    name: '/configuration-center/quick/quick',
    meta: {
      title: '快捷回复配置'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/quick/quick.vue')
  },
  {
    path: '/configuration-center/manage/manage',
    name: '/configuration-center/manage/manage',
    meta: {
      title: '服务原因配置'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/manage/manage.vue')
  },
  {
    path: '/configuration-center/customerServicePerson',
    name: '/configuration-center/customerServicePerson',
    meta: {
      title: '承接人员配置'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/customerServicePerson.vue')
  },
  {
    path: '/configuration-center/entrance/entrance',
    name: '/configuration-center/entrance/entrance',
    meta: {
      title: '入口管理'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/entrance/entrance.vue')
  },
  {
    path: '/configuration-center/entrance/entrance_detail',
    name: '/configuration-center/entrance/entrance_detail',
    meta: {
      title: '云集承担流量配置'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/entrance/entrance_detail.vue')
  },
  {
    path: '/configuration-center/customerMament/customerList',
    name: '/configuration-center/customerMament/customerList',
    meta: {
      title: '客服中心管理'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/customerMament/customerList.vue')
  },
  {
    path: '/configuration-center/customerMament/customerDetails',
    name: '/configuration-center/customerMament/customerDetails',
    meta: {
      title: '客服中心配置'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/customerMament/customerDetails.vue')
  },
  {
    path: '/configuration-center/entrance/entrance_fuwu',
    name: '/configuration-center/entrance/entrance_fuwu',
    meta: {
      title: '服务配置'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/entrance/entrance_fuwu.vue')
  },
  {
    path: '/configuration-center/gragProgramme/gragList',
    name: '/configuration-center/gragProgramme/gragList',
    meta: {
      title: '客服中心灰度流量控制'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/gragProgramme/gragList.vue')
  },
  {
    path: '/configuration-center/popStore',
    name: 'popStore',
    meta: {
      title: '商家店铺管理'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center-popStore" */ '../views/configurationCenter/popStore/index.vue')
  },
  {
    path: '/configuration-center/workOrderLimit',
    name: 'workOrderLimit',
    meta: {
      title: '工单业务域'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center-popStore" */
      '../views/configurationCenter/workOrder/LimitConfitList.vue'
    )
  },
  {
    path: '/configuration-center/serviceManpowerSet',
    name: 'serviceManpowerSet',
    meta: {
      title: '客服人力设置'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center-popStore" */
      '../views/configurationCenter/serviceManpowerSet/serviceManpowerSet.vue'
    )
  },
  {
    path: '/configuration-center/recommendedConfiguration',
    name: 'recommendedConfiguration',
    meta: {
      title: '推荐配置'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center-popStore" */
      '../views/configurationCenter/recommendedConfiguration/index.vue'
    )
  },
  {
    path: '/configuration-center/recommendedConfiguration/details',
    name: 'recommendedConfiguration/details',
    meta: {
      title: '配置详情'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center-popStore" */
      '../views/configurationCenter/recommendedConfiguration/details.vue'
    )  
  },
  {    
    path: '/configuration-center/cardAdmin',
    name: 'cardAdmin',
    meta: {
      title: '卡片管理'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center-popStore" */ '../views/configurationCenter/cardAdmin/cardList.vue')
  },
  {
    path: '/configuration-center/cradDetails',
    name: 'cradDetails',
    meta: {
      title: '卡片详情'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center-popStore" */ '../views/configurationCenter/cardAdmin/cradDetails.vue')
  },
  {
    path: '/configuration-center/columnConfig',
    name: 'columnConfig',
    meta: {
      title: '栏目配置'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/businessCenter/columnConfig.vue')
  },
  {
    path: '/configuration-center/knowledgeConfig',
    name: 'knowledgeConfig',
    meta: {
      title: '知识配置'
    },
    component: () => import(
      /* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/businessCenter/knowledgeConfig.vue'
    )
  },
  {
    path: '/configuration-center/mainBody',
    name: 'mainBody',
    meta: {
      title: '服务主体管理'
    },
    component: () => import(
      /* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/mainBody/mainBody.vue'
    )
  },
  {
    path: '/configuration-center/tenantManager',
    name: 'tenantManager',
    meta: {
      title: '租户管理'
    },
    component: () => import(
      /* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/tenantManager/tenantManager.vue'
    )
  },
  {
    path: '/configuration-center/tenantManager/detail',
    name: '/detail',
    meta: {
      title: '租户详情'
    },
    component: () => import(
      /* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/tenantManager/edit.vue'
    )
  },
  {
    path: '/configuration-center/humanResource',
    name: 'tenantManager',
    meta: {
      title: '客服人力监控批量配置'
    },
    component: () => import(
      /* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/humanResource/index.vue'
    )
  },
  {
    path: '/configuration-center/abilityList',
    name: 'abilityList',
    meta: {
      title: '通用配置 - 功能列表'
    },
    component: () => import(
      /* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/commonConfig/abilityList.vue'
    )
  },
  {
    path: '/configuration-center/ruleList',
    name: 'ruleList',
    meta: {
      title: '通用配置 - 规则列表'
    },
    component: () => import(
      /* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/commonConfig/ruleList.vue'
    )
  },
  {
    path: '/configuration-center/editConfig',
    name: 'editConfig',
    meta: {
      title: '通用配置 - 编辑规则'
    },
    component: () => import(
      /* webpackChunkName: "example-configuration-center" */ '../views/configurationCenter/commonConfig/editConfig.vue'
    )
  }
]
